import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loadAuthenticatedBookingProfile } from '../lib/bookingService';
import { supabase } from '../lib/supabaseClient';

export const useAuthenticatedBookingProfile = ({ redirectToLogin = true } = {}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState({ name: '', email: '', phone: '' });

  useEffect(() => {
    let active = true;

    const loadProfile = async () => {
      try {
        const nextProfile = await loadAuthenticatedBookingProfile();

        if (!nextProfile.email && !localStorage.getItem('userAuthenticated')) {
          if (redirectToLogin) {
            navigate('/login', { replace: true });
          }
          return;
        }

        if (active) {
          setProfile(nextProfile);
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    loadProfile();

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange(() => {
      loadProfile();
    });

    return () => {
      active = false;
      subscription.unsubscribe();
    };
  }, [navigate, redirectToLogin]);

  return { ...profile, loading };
};
